// extracted by mini-css-extract-plugin
export default {"allBranches":"AllBranches_allBranches__5kTMR","branchSorting":"AllBranches_branchSorting__HaYuh","branchList":"AllBranches_branchList__HiqLF"};